import { render, staticRenderFns } from "./LiveOnPassions.vue?vue&type=template&id=29a38d6e&scoped=true"
import script from "./LiveOnPassions.js?vue&type=script&lang=js&external"
export * from "./LiveOnPassions.js?vue&type=script&lang=js&external"
import style0 from "./LiveOnPassions.scss?vue&type=style&index=0&id=29a38d6e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a38d6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotVideoInline: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/VideoInline/VideoInline.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
